// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2spNQ","showButton":"App_showButton__g4J_m","logo":"App_logo__2tyFN","content":"App_content__kOyc8"};